export default "__VITE_ASSET__DbGcQf60__"